module.exports = __webpack_public_path__ + "static/media/rupor.2ef26346.png";